import MarkdownInput from './MarkdownInput';

const markdown = {
  id: 'markdown',
  name: 'Markdown',
  Input: MarkdownInput,
  setInitialContent: content => {
    return {
      text: content.text || ''
    };
  },
  valid: content => {
    return content.text.length > 0;
  },
  snippet: `{
    "type": "markdown",
    "content": {
      "text": ""
    }
}`
};

export default markdown;
